import { render, staticRenderFns } from "./postList.vue?vue&type=template&id=4af4af64&scoped=true&"
import script from "./postList.vue?vue&type=script&lang=js&"
export * from "./postList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4af64",
  null
  
)

export default component.exports